@if (actions().length) {
    <button
        mat-icon-button
        [matMenuTriggerFor]="menu"
        [attr.aria-label]="'a11y.dataList.rowActions' | translate"
        (click)="$event.stopPropagation()"
        [disabled]="row().empty"
        [tabIndex]="triggerTabIndex()"
        data-testid="datalist-cell-actions-button-trigger">
        <mat-icon aria-hidden="true">more_vert</mat-icon>
    </button>

    <mat-menu #menu="matMenu" class="cipo cipo-menu">
        @for (action of actions(); track action.id) {
            @if (!action.condition || action.condition(row())) {
                @if (action.subItems?.length > 0) {
                    <button
                        mat-menu-item
                        [matMenuTriggerFor]="rowSubMenu"
                        [matMenuTriggerData]="{ subItems: action.subItems, row: row() }"
                        [attr.data-testid]="
                            'datalist-cell-actions-button-menu-item datalist-cell-actions-button-menu-item-' + action.id
                        ">
                        @if (hasLeftIcons()) {
                            <mat-icon class="material-icons-outlined m-r">
                                {{ action.leftIcon }}
                            </mat-icon>
                        }
                        <span fxLayout fxLayoutAlign="space-between center" [ngClass]="{ 'm-l': hasLeftIcons() }">
                            {{ action.displayName | translate }}
                            @if (hasRightIcons()) {
                                <mat-icon class="material-symbols-outlined end-icon">
                                    {{ action.rightIcon }}
                                </mat-icon>
                            }
                        </span>
                    </button>
                } @else {
                    <button
                        mat-menu-item
                        (click)="onActionClick(action)"
                        [attr.data-testid]="
                            'datalist-cell-actions-button-menu-item datalist-cell-actions-button-menu-item-' + action.id
                        ">
                        @if (hasLeftIcons()) {
                            <mat-icon class="material-icons-outlined m-r">
                                {{ action.leftIcon }}
                            </mat-icon>
                        }
                        <span fxLayout fxLayoutAlign="space-between center" [ngClass]="{ 'm-l': hasLeftIcons() }">
                            {{ action.displayName | translate }}
                            @if (hasRightIcons()) {
                                <mat-icon class="material-symbols-outlined end-icon">
                                    {{ action.rightIcon }}
                                </mat-icon>
                            }
                        </span>
                    </button>
                }
            }
        }
    </mat-menu>

    <!-- Level-2 sub-menu -->
    <mat-menu #rowSubMenu="matMenu" class="cipo cipo-menu">
        <ng-template matMenuContent let-subItems="subItems" let-row="row">
            @for (sub of subItems; track $index) {
                @if (sub.subItems?.length > 1) {
                    <button
                        mat-menu-item
                        [matMenuTriggerFor]="rowRolesMenu"
                        [matMenuTriggerData]="{ subItems: sub.subItems, row: row }">
                        @if (sub.leftIcon) {
                            <mat-icon class="material-icons-outlined m-r">
                                {{ sub.leftIcon }}
                            </mat-icon>
                        }
                        <span [ngClass]="{ 'm-l': sub.leftIcon }">
                            {{ sub.displayName }}
                        </span>
                    </button>
                } @else {
                    <button mat-menu-item (click)="onSubActionClick(sub, row)">
                        @if (sub.leftIcon) {
                            <mat-icon class="material-icons-outlined m-r">
                                {{ sub.leftIcon }}
                            </mat-icon>
                        }
                        <span [ngClass]="{ 'm-l': sub.leftIcon }">
                            {{ sub.displayName }}
                        </span>
                    </button>
                }
            }
        </ng-template>
    </mat-menu>

    <!-- Level-3 sub-menu -->
    <mat-menu #rowRolesMenu="matMenu" class="cipo cipo-menu">
        <ng-template matMenuContent let-subItems="subItems" let-row="row">
            @for (role of subItems; track $index) {
                <button mat-menu-item (click)="role.onSelect(row)">
                    @if (role.leftIcon) {
                        <mat-icon class="material-icons-outlined m-r">
                            {{ role.leftIcon }}
                        </mat-icon>
                    }
                    <span [ngClass]="{ 'm-l': role.leftIcon }">
                        {{ role.displayName }}
                    </span>
                </button>
            }
        </ng-template>
    </mat-menu>
}
